import { cs } from "../../core/classSet";
import { isLinkMime, isValidImageAttachment } from "../../core/utils";
import { IAttachment } from "../../typings/filterEntities";
import ExternalLink from "../ExternalLink/ExternalLink";
import { ArrowIcon, CalendarIcon, CameraIcon, FileIcon, LinkIcon } from "../Icons/Icons";
import styles from "./ProcedureElements.module.css";

function Input({ className, placeholder }: { className?: string; placeholder?: string }) {
  return (
    <input
      className={cs(styles.input, className)}
      placeholder={placeholder || "Enter Text"}
      readOnly={true}
      type="text"
    />
  );
}

export function ProcedureTextInput() {
  return (
    <div className={styles.wrapper}>
      <Input />
    </div>
  );
}

export function ProcedureNumberInput() {
  return (
    <div className={styles.wrapper}>
      <Input placeholder="0" />
    </div>
  );
}

export function ProcedureNumberAmountInput() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.amount}>$</div>
      <Input className={styles.amountInput} placeholder="0" />
    </div>
  );
}

export function ProcedureCheckboxInput({ label, required }: { label: string; required?: boolean }) {
  return (
    <label className={styles.checkboxRadioWrapper}>
      <input className={styles.checkbox} checked={false} readOnly={true} type="checkbox" />
      <h4 className={cs(styles.label, [styles.required, required])}>{label}</h4>
    </label>
  );
}

export function ProcedureRadioInput({ label, required }: { label: string; required?: boolean }) {
  return (
    <label className={styles.checkboxRadioWrapper}>
      <input className={styles.radio} checked={false} readOnly={true} type="radio" />
      <h4 className={cs(styles.label, [styles.required, required])}>{label}</h4>
    </label>
  );
}

export function ProcedureDateInput({ isDateAndTime }: { isDateAndTime?: boolean | null }) {
  if (isDateAndTime) {
    return (
      <div className={styles.dateTimeWrapper}>
        <div className={styles.wrapper}>
          <Input placeholder="mm/dd/yyyy" />
          <div className={styles.calendar}>
            <CalendarIcon />
          </div>
        </div>
        <div className={styles.wrapper}>
          <Input className={styles.timeInput} placeholder="-- : --" />
          <div className={styles.chevron}>
            <ArrowIcon direction="down" width={14} height={14} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <Input placeholder="mm/dd/yyyy" />
      <div className={styles.calendar}>
        <CalendarIcon />
      </div>
    </div>
  );
}

export function ProcedureMeterInput({ meterName, unit }: { meterName: string; unit: string }) {
  return (
    <>
      <h5 className={styles.meterName}>{meterName}</h5>
      <div className={styles.wrapper}>
        <Input />
        <div className={styles.unit}>{unit}</div>
      </div>
    </>
  );
}

export function ProcedureInspectionCheckInput() {
  return (
    <ul className={styles.buttonWrapper}>
      <li className={styles.buttonPass}>Pass</li>
      <li className={styles.buttonFlag}>Flag</li>
      <li className={styles.buttonFail}>Fail</li>
    </ul>
  );
}

export function ProcedureYesNoNaInput() {
  return (
    <ul className={styles.buttonWrapper}>
      <li className={styles.button}>Yes</li>
      <li className={styles.button}>No</li>
      <li className={styles.button}>N / A</li>
    </ul>
  );
}

export function ProcedureImageUploadInput() {
  return (
    <div className={styles.imageUpload}>
      <CameraIcon />
      Add or drag pictures
    </div>
  );
}

export function ProcedureSignatureInput() {
  return <div className={styles.signature}>Click here to sign</div>;
}

export function ProcedureAttachment({ attachment }: { attachment: IAttachment }) {
  if (isValidImageAttachment(attachment)) {
    return (
      <ExternalLink href={attachment.originalUrl}>
        <img
          alt={attachment.fileName}
          className={styles.imageAttachment}
          height={attachment.height ?? undefined}
          src={attachment.resizableUrl}
          title={attachment.fileName}
          width={attachment.width ?? undefined}
        />
      </ExternalLink>
    );
  }
  return (
    <ExternalLink className={styles.fileAttachment} href={attachment.originalUrl}>
      {isLinkMime(attachment.mimeType) ? <LinkIcon /> : <FileIcon />}
      {attachment.fileName}
    </ExternalLink>
  );
}
